// extracted by mini-css-extract-plugin
module.exports = {"textEllipsis":"TextEllipsis_textEllipsis__X7jgC"};